import { createElementBlock, openBlock, createElementVNode } from 'vue';

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Website Icons",
  viewBox: "0 0 100 100"
};

function render(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", { d: "M29.52 44.88c-3.95 0-7.52 1.53-10.24 3.99v-3.99c0-8.47 6.89-15.36 15.36-15.36h2.56c1.42 0 2.56-1.14 2.56-2.56s-1.14-2.56-2.56-2.56h-2.56c-11.29 0-20.48 9.19-20.48 20.48v15.36c0 8.48 6.88 15.36 15.36 15.36s15.36-6.88 15.36-15.36S38 44.88 29.52 44.88Zm40.96 0c-3.95 0-7.52 1.53-10.24 3.99v-3.99c0-8.47 6.89-15.36 15.36-15.36h2.56c1.42 0 2.56-1.14 2.56-2.56s-1.14-2.56-2.56-2.56H75.6c-11.29 0-20.48 9.19-20.48 20.48v15.36c0 8.48 6.88 15.36 15.36 15.36s15.36-6.88 15.36-15.36-6.88-15.36-15.36-15.36Z" }, null, -1)
  ])))
}
const quoteIcon = { render: render };

export { quoteIcon as default, render };
